import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { Theme } from 'localmed-core';
import { space, SpaceProps, width, WidthProps } from 'styled-system';

type Props = SpaceProps & WidthProps;

const InputGroup = styled('div')<Props, Theme>(
  (props) => css`
    display: flex;
    align-items: stretch;
    width: 100%;

    button {
      /* Remove the vertical padding and allow 'align-items: stretch;'
         to match the heights. */
      padding: 0 ${props.theme.space.sm};
      border: none;
      transform: none;
      box-shadow: none;
    }

    /* '> div' targets the Input's wrapper div. Unfortunately nested component
       selectors aren't currently working.  */
    > div {
      flex: 1;
    }

    input {
      border-right: none;
    }

    > *:first-of-type,
    > *:first-of-type input {
      border-radius: ${props.theme.radii.md} 0 0 ${props.theme.radii.md};
    }

    > *:last-child,
    > *:last-child input {
      border-radius: 0 ${props.theme.radii.md} ${props.theme.radii.md} 0;
    }
  `,
  space,
  width
);

export default InputGroup;
